"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContestFloatingHeaderVerify = function ContestFloatingHeaderVerify(_ref) {
  var translations = _ref.translations,
      isScrolledDown = _ref.isScrolledDown;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.FloatingHeader, {
    isScrolledDown: isScrolledDown,
    justifyContent: "center",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Alert, {
      isDanger: true,
      margin: "0 0 4px",
      padding: "0.25rem 0.75rem",
      children: translations === null || translations === void 0 ? void 0 : translations.warningVerifyPhone
    })
  });
};

var _default = ContestFloatingHeaderVerify;
exports.default = _default;